import React from 'react';

interface SkipProps {
  opacity?: number;
  size?: number;
}

export const Skip = ({ opacity = 0.6, size = 32 }: SkipProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16 32C13.8144 32 11.7542 31.5817 9.81961 30.7451C7.89542 29.9085 6.19608 28.7529 4.72157 27.2784C3.24706 25.8039 2.0915 24.1046 1.2549 22.1804C0.418301 20.2458 0 18.1856 0 16C0 13.8144 0.418301 11.7595 1.2549 9.83529C2.0915 7.90065 3.24183 6.19608 4.70588 4.72157C6.18039 3.24706 7.87974 2.0915 9.80392 1.2549C11.7386 0.418301 13.7987 0 15.9843 0C18.1699 0 20.2301 0.418301 22.1647 1.2549C24.0993 2.0915 25.8039 3.24706 27.2784 4.72157C28.7529 6.19608 29.9085 7.90065 30.7451 9.83529C31.5817 11.7595 32 13.8144 32 16C32 18.1856 31.5817 20.2458 30.7451 22.1804C29.9085 24.1046 28.7529 25.8039 27.2784 27.2784C25.8039 28.7529 24.0993 29.9085 22.1647 30.7451C20.2405 31.5817 18.1856 32 16 32ZM8.95686 21.1608C8.95686 21.8301 9.2915 22.1647 9.96078 22.1647H11.702C12.3712 22.1647 12.7059 21.8301 12.7059 21.1608V16.4863C12.8209 16.7477 13.0353 16.9673 13.349 17.1451L21.0667 21.6784C21.2131 21.7725 21.3542 21.8405 21.4902 21.8824C21.6366 21.9242 21.783 21.9451 21.9294 21.9451C22.2327 21.9451 22.4889 21.8405 22.698 21.6314C22.9072 21.4222 23.0118 21.1033 23.0118 20.6745V11.3725C23.0118 10.9542 22.9072 10.6405 22.698 10.4314C22.4889 10.2118 22.2327 10.102 21.9294 10.102C21.783 10.102 21.6366 10.1229 21.4902 10.1647C21.3542 10.2065 21.2131 10.2745 21.0667 10.3686L13.349 14.902C13.0353 15.0797 12.8209 15.2993 12.7059 15.5608V10.8392C12.7059 10.1699 12.3712 9.83529 11.702 9.83529H9.96078C9.2915 9.83529 8.95686 10.1699 8.95686 10.8392V21.1608Z'
      fill='var(--t3k-accent)'
      fillOpacity={opacity}
    />
  </svg>
);
